<template>

    <v-list-item class="action">
        <div class="d-flex align-items-center overflow-hidden">
            <v-handle v-if="campaign.type === 'automatic'" class="mr-10" :size="24" />
            <v-icon class="mr-10" :symbol="'action-' + action.type" :size="40" :radius="3" />
            <div class="info overflow-hidden">
                <span class="text-nowrap">{{ action.title }}</span><br>
                <span class="small text-secondary">{{ action.type }}</span>
            </div>
        </div>
        <div>
            <transition name="modal">
                <v-modal-action-delete v-if="showModal === 'action-delete-' + action.id" :action="action" @deleted="getActions" />
                <v-modal-action-duplicate v-if="showModal === 'action-duplicate-' + action.id" :action="action" @duplicated="getActions" />
            </transition>
            <transition name="modal">
                <v-action-modals :action="action" />
            </transition>
            <v-button-toolbar class="float-right">
                <div v-if="action.incomplete" class="p-10" v-tooltip="{ content: 'Action is incomplete' }">
                    <i class="fas fa-exclamation-triangle text-danger fs-20"></i>
                </div>
                <v-button size="sm" @click.native="editAction">Edit</v-button>
                <v-dropdown
                    type="secondary"
                    label="More"
                    :items="options"
                    :show-selected="false"
                    :menu-right="true"
                    @change="onOptionSelected">
                </v-dropdown>
            </v-button-toolbar>
        </div>
    </v-list-item>

</template>

<style scoped lang="scss">

    .list-item.action {
        grid-auto-columns: 1fr 200px;
        .info {
            text-overflow: ellipsis;
        }
    }

</style>

<script>

import ActionModals from '@pages/automations/components/ActionModals';
import CampaignApi from '@api/CampaignApi';
import ModalActionDelete from '@modals/action/ModalActionDelete';
import ModalActionDuplicate from '@modals/action/ModalActionDuplicate';

export default {

    components: {
        'v-action-modals': ActionModals,
        'v-modal-action-delete': ModalActionDelete,
        'v-modal-action-duplicate': ModalActionDuplicate,
    },

    props: {
        action: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            edit: false,
        }
    },

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

        options() {
            let options = [];
            if (['email', 'webhook'].includes(this.action.type)) {
                options.push({ key: 'test-' + this.action.type, value: 'Test Action' });
            }
            options.push({ key: 'duplicate', value: 'Duplicate Action' });
            options.push({ key: 'delete', value: 'Delete Action' });
            return options;
        },

    },

    methods: {

        onOptionSelected(item) {
            this.$store.commit('showModal', `action-${item.key}-` + this.action.id);
        },

        editAction() {
            this.$store.commit('showModal', `action-edit-${this.action.type}-` + this.action.id);
        },

        getActions() {
            this.$store.commit('loading', true);
            CampaignApi.getCampaign(this.action.campaign_id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('campaign/setActions', response.data.data.actions);
                })
                .catch((error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
